// extracted by mini-css-extract-plugin
export default {"content":"styles_content__aTqD5","title":"styles_title__TWmPd","desc":"styles_desc__tJhcF"};